import { render, staticRenderFns } from "./billwerk-order.vue?vue&type=template&id=0e0424e2&scoped=true&"
import script from "./billwerk-order.vue?vue&type=script&lang=js&"
export * from "./billwerk-order.vue?vue&type=script&lang=js&"
import style0 from "./billwerk-order.vue?vue&type=style&index=0&id=0e0424e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0424e2",
  null
  
)

export default component.exports